import { actions } from '../../../utils/constants';

const INITIAL_STATE = {
  form: {},
  requesting: false,
  disable: true,
}

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {

    case actions.CHANGE_LOGIN_FORM:
      return { ...state, form: { ...state.form, [payload.id]: payload.value } };

    case actions.TOOGLE_DISABLE:
      return { ...state, disable: payload };

    case actions.TOOGLE_REQUESTING:
      return { ...state, requesting: payload }

    case actions.RESET_FORMS:
      return { ...state, form: {} };

    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/App/containers/login/login.reducer.js